export default "<ion-app>\n  <bottom-drawer></bottom-drawer>\n  <ion-router-outlet></ion-router-outlet>\n</ion-app>";